export const FEE = String(process.env.REACT_APP_DOMAIN).includes("payping.ir") ? 4000 : 0;
export const MIN_AMOUNT = (String(process.env.REACT_APP_DOMAIN).includes("payping.ir") ? 5000 : 1000) + FEE;
export const EXPIRATION_DIRECT_METHOD = 7;
